// ############################################
// TODO: Move this to appropriate lib in future
// ############################################

import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpInterceptor,
    HttpHeaders,
    HttpHeaderResponse,
    HttpProgressEvent,
    HttpResponse,
    HttpSentEvent,
    HttpUserEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

const CACHE_CONTROL = 'Cache-Control';
const CACHE_CONTROL_VALUE = 'no-cache, no-store, must-revalidate';

@Injectable()
export class TmInterceptor implements HttpInterceptor {
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<
        | HttpSentEvent
        | HttpHeaderResponse
        | HttpProgressEvent
        | HttpResponse<any>
        | HttpUserEvent<any>
    > {
        const setHeaders = (headers: HttpHeaders) => {
            return (
                headers
                    // prevent caching in IE, in particular IE11.
                    .set(CACHE_CONTROL, CACHE_CONTROL_VALUE)
                    .set('Pragma', 'no-cache')
                    .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
                    .set('If-Modified-Since', '0')
            );
        };
        return next.handle(
            request.clone({
                headers: setHeaders(request.headers)
            })
        );
    }
}
